export default {
  eyebrow: 'Portal do parceiro',
  title: 'Taxas de processamento',
  description:
    'Você paga as taxas da Stripe em todos os pagamentos online. A taxa de processamento definida aqui é cobrada aos seus restaurantes para as cobrir, a menos que um restaurante tenha uma taxa própria.',
  card_title: 'Taxa de processamento predefinida',
  hint: 'Percentagem em %, mais um valor fixo e mínimo opcionais por pagamento. «Qualquer método de pagamento» aplica-se quando não existe uma taxa específica do método. Uma alteração aplica-se aos pagamentos efetuados após ser guardada.',
  hint_single:
    'A taxa de processamento aplica-se a todos os métodos de pagamento online que não têm uma taxa própria. Uma alteração aplica-se aos pagamentos efetuados depois de ser guardada.',
  hidden_rates:
    'Alguns métodos de pagamento têm também a sua própria taxa, definida pelo suporte da sua plataforma. Essas aplicam-se em vez desta taxa.',
  empty: {
    title: 'Não está definida nenhuma taxa de processamento predefinida',
    description:
      'Até definir uma taxa, ou confirmar que não cobra qualquer taxa de processamento aos seus restaurantes, os seus restaurantes no Stripe não podem entrar em funcionamento e os que já estão ativos não aceitam pagamentos online (o numerário continua a funcionar).',
  },
  consent: {
    give: 'Pagamos nós as taxas do Stripe (confirmar margem de 0%)',
    given_title: 'Margem de 0% confirmada',
    given:
      'Confirmado por {{name}} em {{date}}: aos restaurantes sem taxa própria não é cobrada qualquer taxa de processamento e você paga as taxas do Stripe sobre os respetivos pagamentos.',
    unknown_manager: 'um antigo gestor',
    withdraw: 'Retirar',
    withdraw_confirm: {
      title: 'Retirar a confirmação da margem de 0%?',
      description:
        'Os restaurantes sem taxa própria deixam de poder entrar em funcionamento e os que já estão ativos deixam de aceitar pagamentos online até definir uma taxa ou voltar a confirmar.',
    },
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'Não foi possível carregar as suas taxas de processamento.',
    failed_to_save_changes: 'Não foi possível guardar as suas taxas de processamento.',
    changes_got_saved: 'Taxas de processamento guardadas',
    consent_given: 'Margem de 0% confirmada',
    consent_withdrawn: 'Confirmação retirada',
  },
};
